export const FREE_SHIPPING_THRESHOLD = 50

export type ShippingMethod = 'standaard' | 'express'

export const shippingOptions: { id: ShippingMethod; label: string; detail: string; price: number }[] = [
  { id: 'standaard', label: 'Standaard', detail: 'Morgen in huis bij bestelling vóór 22:00', price: 4.95 },
  { id: 'express', label: 'Express', detail: 'Morgen vóór 12:00 in huis', price: 7.95 },
]

export function shippingCost(subtotal: number, method: ShippingMethod = 'standaard'): number {
  const option = shippingOptions.find((o) => o.id === method) ?? shippingOptions[0]
  if (method === 'standaard' && subtotal >= FREE_SHIPPING_THRESHOLD) return 0
  return option.price
}
